module.exports = __webpack_public_path__ + "img/02.61b28b2a.jpeg";